import CorporationsConfig from './CorporationsConfig';
import SoleConfig from './SoleConfig';
import LlcConfig from './LlcConfig';
import LlpConfig from './LlpConfig';
import PartnershipConfig from './PartnershipConfig';

const businessOwnershipsConfigs = [
    CorporationsConfig, 
    CorporationsConfig, 
    SoleConfig, 
    LlcConfig, 
    LlpConfig, 
    CorporationsConfig,
    PartnershipConfig,
];

export default businessOwnershipsConfigs;


// WEBPACK FOOTER //
// ./src/areas/certification/steps/articles/UploadsConfig/UploadsConfig.js